/* eslint-disable no-return-assign */
import React, {
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Modal from '@digital-hig/mui/dist/Modal';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
// eslint-disable-next-line import/no-extraneous-dependencies
import TextInput from '@mui/material/Input';
// eslint-disable-next-line import/no-extraneous-dependencies
import Checkbox from '@mui/material/Checkbox';
// eslint-disable-next-line import/no-extraneous-dependencies
import FormControl from '@mui/material/FormControl';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import FormControlLabel from '@mui/material/FormControlLabel';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { detect } from 'detect-browser';
// eslint-disable-next-line import/no-extraneous-dependencies
import SvgIcon from '@mui/material/SvgIcon';
import AddIcon from '@digital-hig/icon/lib/esm/icons/add';
// eslint-disable-next-line import/no-extraneous-dependencies
import FormHelperText from '@mui/material/FormHelperText';
// eslint-disable-next-line import/no-extraneous-dependencies
import InputLabel from '@mui/material/InputLabel';
import Typography from '@digital-hig/mui/dist/Typography';

import Switch from './switch';
import {
  createListData, getUserDetails, getLists, addListItem, deleteListItem, getLearningRecords, hasFetchedLists, fetchListsData, isFetchingLists,
} from '../store/userSlice';
import { sendMessage } from '../store/messagingSlice';
import EnvContext from '../common/envContext';
import {
  ENVIRONMENT, LIST_PERMISSIONS_UNLISTED, LIST_PERMISSIONS_PRIVATE, LIST_ID_BOOKMARKS, LIST_ID_FOLLOWED, styleVariables,
  LIST_TITLE_MAX, LIST_DESCRIPTION_MAX, LIST_TYPE_COURSE, LIST_TYPE_MODULE,
  VERSION,
} from '../common/constants';
import { generateLRSID, serializeElement } from '../common/utilities';
import { profanityFilter } from '../common/ugcFilters';
import { generateCourseDataAnalyticsString, triggerErrorBanner, triggerManualLinkClick } from '../common/analyticsApi';
import Banner from './bannerHOC';

const RootElement = styled.div`

.Mui-checked svg  {
  
  rect {
    fill: ${styleVariables.black};
  }
}

.Montainer {
  padding: 0px;
  margin: 0 -2rem;
  max-width: 590px;

  .MuiTypography-root.MuiDialogTitle-root {
    padding: 24px 32px !important;
  }
  .create-new-list,
  .new-list-description {
    align-items: center;
    font-size: 14px;
    padding: 0px 16px 10px 10px;
    box-shadow: inset 0px -1px 0px rgba(0, 0, 0, 0.1);
    min-height: 32px;

    svg {
      height: 18px;
      width: 18px;
      margin-left: 8px;
    }
  }

  .new-list-description {
    padding-left: 32px;
    height: auto;
    display: flex;
  }
  .modal-body {
    max-height: 260px;
    padding: 18px 32px 0px;
    overflow-y: auto;

    .Mui-error {
      font-size: 14px;
    }

    .Mui-inputFooter .Mui-error {
      margin-bottom: 6px;
    }

    .padding {
      height: 12px;
    }

    .MuiInputLabel-root {
      font-size: 12px;
      line-height: 16px;

      .optional {
        font-style: normal;
      }
    }

    .MuiInput-inputMultiline {
      font-size: 14px;
      line-height: 18px;
      height: 60px;
    }

    .characters {
      opacity: 0.6;
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 3px;
    }

    ul {
      margin: 6px 0 0 0;
      padding: 0;

      li {
        list-style-type: none;

        label {
          display: flex;
          align-items: center;
          .MuiFormControlLabel-label {
            font-size: 16px;
            line-height: 16px;
            margin-bottom: 2px;
          }
        }
      }
    }
  }
  .private-list {
    display: flex;
    flex-direction: column;
    padding: 32px 32px 8px;
    .toggle-btn {
      font-size: 14px;
    }
    p {
      flex: 1;
      font-size: 14px;
    }
    .MuiFormControlLabel-label {
      font-size: 16px;
      line-height: 20px;
      margin-left: 8px;
    }
  }
  



  p.MuiFormHelperText-root {
    padding: 10px 0px 1px;
  }

}
.modal-footer {
  border: 0px;
  button {
    margin-left: 12px;
  }
}

 `;
const ListModal = ({
  displayModal, data, analyticsArea,
}) => {
  const [isOpenViewListModal, setIsOpenViewListModal] = useState(true);
  const [isOpenCreateNewList, setIsOpenCreateNewList] = useState(false);
  const [localError, setLocalError] = useState(null);
  const [saveActive, setSaveActive] = useState(false);
  const [myListTitle, setMyListTitle] = useState('');
  const [myListDescription, setMyListDescription] = useState('');
  const dispatch = useDispatch();
  const envContext = useContext(EnvContext);
  const env = envContext[ENVIRONMENT];
  const appVersion = envContext[VERSION];
  const userDetails = useSelector(getUserDetails);
  const listsData = useSelector(getLists);
  const alreadyFetchedLists = useSelector(hasFetchedLists);
  const currentlyFetchingLists = useSelector(isFetchingLists);
  const [orderedLists, setOrderedLists] = useState([]);
  const { oa2Token } = userDetails;
  const titleRef = useRef();
  const descriptionRef = useRef();
  const publicRef = useRef();
  const checkboxRefs = useRef({});
  const [titleError, setTitleError] = useState(null);
  const [descriptionError, setDescriptionError] = useState(null);
  const { id } = data;
  const learningRecords = useSelector(getLearningRecords);
  const [hasTriggeredError, setHasTriggeredError] = useState(false);
  const localErrorMessage = 'Course or Module has not been added. Please try again.';
  const isCourse = data.objectType.toUpperCase() === LIST_TYPE_COURSE;

  if (localError && !hasTriggeredError) {
    triggerErrorBanner({
      errorLocation: 'list modal', errorType: 'list service error', errorCode: localError.errorCode, errorReason: localError.errorMessage, errorMessage: localErrorMessage,
    });
    setHasTriggeredError(true);
  }

  if (!localError && hasTriggeredError) {
    setHasTriggeredError(false);
  }

  useEffect(() => {
    if (!currentlyFetchingLists && !alreadyFetchedLists) {
      dispatch(fetchListsData({
        oa2Token,
        env,
        appVersion,
      }));
    }
  }, []);

  const triggerClickTracking = ({ action }) => {
    triggerManualLinkClick({ linkTitle: `${analyticsArea}:${action}:${generateCourseDataAnalyticsString({ data, env, learningRecords })}` });
  };
  useEffect(() => {
    if (isOpenViewListModal) {
      triggerClickTracking({ action: 'add to list modal shown' });
    }
  }, [isOpenViewListModal]);

  useEffect(() => {
    if (isOpenCreateNewList) {
      titleRef?.current?.focus();
      titleRef?.current?.select();
    }

    if (!listsData || !listsData.filter((list) => ![LIST_ID_BOOKMARKS, LIST_ID_FOLLOWED].includes(list.listId)).length) {
      setMyListTitle('My list');
    } else {
      setMyListTitle(`My list #${(listsData.filter((list) => ![LIST_ID_BOOKMARKS, LIST_ID_FOLLOWED].includes(list.listId))).length + 1}`);
    }
  }, [isOpenCreateNewList]);

  const closeViewListModal = () => {
    setIsOpenViewListModal(false);
    displayModal(false);
  };

  const openCreateNewListModal = () => {
    setIsOpenCreateNewList(true);
  };

  const handleListTitleOnChange = (e) => {
    setMyListTitle(e.target.value.substr(0, LIST_TITLE_MAX));
  };

  const handleListDescriptionOnChange = (e) => {
    setMyListDescription(e.target.value.substr(0, LIST_DESCRIPTION_MAX));
  };

  const handleCheckboxChange = () => {
    const modifiedBoxes = [];
    Object.keys(checkboxRefs.current).forEach((checkboxId) => {
      const checkbox = checkboxRefs.current[checkboxId];
      if (checkbox) {
        if (listsData.length) { // List data exists for user
          const filteredLists = listsData.filter((list) => checkboxId.endsWith(list.listId));
          if (filteredLists && filteredLists[0]) {
            const list = filteredLists[0];
            const listItem = list?.listItems?.find((item) => item.resourceId.endsWith(id));
            if (checkbox.checked) {
              if (!listItem) {
                modifiedBoxes.push(checkboxId);
              }
            } else if (!checkbox.checked) {
              if (listItem) {
                modifiedBoxes.push(checkboxId);
              }
            }
          }
        }
      }
    });
    setSaveActive(modifiedBoxes.length > 0);
  };

  const saveToLists = () => {
    setLocalError(null);
    const addRemovePromises = [];
    Object.keys(checkboxRefs.current).forEach((checkboxId) => {
      const checkbox = checkboxRefs.current[checkboxId];
      if (checkbox) {
        if (listsData.length) { // List data exists for user
          const filteredLists = listsData.filter((list) => checkboxId.endsWith(list.listId));
          if (filteredLists && filteredLists[0]) {
            const list = filteredLists[0];
            const listItem = list?.listItems?.find((item) => item.resourceId.endsWith(id));
            if (checkbox.checked) {
              if (!listItem) {
                addRemovePromises.push(dispatch(addListItem({
                  oa2Token,
                  listObject: list,
                  listItemId: generateLRSID({
                    env,
                    id,
                  }),
                  env,
                  type: data.objectType.toUpperCase(),
                  appVersion,
                })).then(unwrapResult));
              }
            } else if (!checkbox.checked) {
              if (listItem) {
                addRemovePromises.push(dispatch(deleteListItem({
                  oa2Token,
                  env,
                  listObject: list,
                  listItemId: generateLRSID({
                    env,
                    id,
                  }),
                  appVersion,
                })).then(unwrapResult));
              }
            }
          }
        }
      }
    });
    Promise.all(addRemovePromises).then(
      () => {
        closeViewListModal();
        dispatch(sendMessage({
          type: 'success',
          children: serializeElement(
            <>
              {'Your lists have been updated. You can access your lists via '}
              <Link to="/dashboard#myLists">My dashboard.</Link>
            </>,
          ),
        }));
      },
      (e) => {
        setLocalError({ errorMessage: e.message, errorCode: e?.response?.status || 500 });
      },
    );
  };

  const createList = () => {
    profanityFilter({
      data: {
        title: titleRef?.current?.value,
        description: descriptionRef?.current?.value,
      },
      env,
    }).then((filterResults) => {
      if (filterResults?.title?.is_offensive || filterResults?.description?.is_offensive) {
        if (filterResults?.title?.is_offensive) {
          setTitleError('This is not a valid title.');
        } else {
          setTitleError(null);
        }
        if (filterResults?.description?.is_offensive) {
          setDescriptionError('This is not a valid description.');
        } else {
          setDescriptionError(null);
        }
      } else {
        const listObject = {
          title: titleRef?.current?.value,
          description: descriptionRef?.current?.value,
          listItems: [
            { resourceId: `https://cdn.contentful.com/spaces/ooioaq2tbzyk/environments/master/entries/${id}`, type: isCourse ? LIST_TYPE_COURSE : LIST_TYPE_MODULE },
          ],
          accessType: publicRef?.current?.checked ? LIST_PERMISSIONS_PRIVATE : LIST_PERMISSIONS_UNLISTED,
        };
        dispatch(createListData({
          listObject, oa2Token, env, appVersion,
        }))
          .then(unwrapResult)
          .then(() => {
            dispatch(sendMessage({
              type: 'success',
              children: serializeElement(
                <>
                  {'Your list has been created. You can access your lists via '}
                  <Link to="/dashboard#myLists">My dashboard.</Link>
                </>,
              ),
            })); closeViewListModal();
          }, (e) => {
            if (e.message === 'title already exists') {
              setTitleError('You already have a list with this name. Add your course or module to that list or create a list with a different name.');
            } else {
              dispatch(sendMessage({
                type: 'error',
                children: serializeElement(
                  <>
                    Your list has not been created. Please try again.
                  </>,
                ),
              }));
            }
          });
      }
    }, () => dispatch(sendMessage({
      type: 'error',
      children: serializeElement(
        <>
          Your list has not been created. Please try again.
        </>,
      ),
    })));
  };

  useEffect(() => {
    // Filter out bookmarks and followed
    const filteredLists = listsData?.filter((list) => ![LIST_ID_BOOKMARKS, LIST_ID_FOLLOWED].includes(list.listId)) || [];
    // Push bookmarks list to the front of the array
    setOrderedLists([...filteredLists]);
    if (filteredLists.length < 1) {
      setIsOpenCreateNewList(true);
    } else {
      setIsOpenCreateNewList(false);
    }
  }, [listsData]);

  // Detect browser state
  const browser = detect();
  return (
    <>
      {/* Only render maximum scale for safari on iOS when modal is open */}
      {isOpenViewListModal && browser?.name === 'ios' ? <meta name="viewport" content="width=device-width, initial-scale=0.5, maximum-scale=0.5" /> : <></>}

      {alreadyFetchedLists ? (
        <Modal
          open={isOpenViewListModal}
          handleClose={closeViewListModal}
          styleVariant="subdivision"
          maxWidth="md"
          closeButtonOutside
          className="listModal"
          CloseButtonProps={{
            onClick: () => {
              triggerClickTracking({ action: 'add to list modal exit' });
            },
          }}
          title={!isOpenCreateNewList ? 'Add a course or module to a list or create a new list.' : 'Create a new list'}
          actions={!isOpenCreateNewList ? (
            <RootElement onClick={(e) => e.stopPropagation()}>
              <div className="modal-footer">
                <Button
                  variant="text"
                  onClick={() => {
                    triggerClickTracking({ action: 'add to list modal cancel' }); closeViewListModal();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  size="defaultSize"
                  variant="contained"
                  onClick={() => {
                    triggerClickTracking({ action: 'add to list modal save' }); saveToLists();
                  }}
                  disabled={!saveActive}
                >
                  Save
                </Button>
              </div>
            </RootElement>
          ) : (
            <RootElement onClick={(e) => e.stopPropagation()}>
              <div className="modal-footer">
                <Button
                  variant="text"
                  onClick={() => {
                    triggerClickTracking({ action: 'add to list modal cancel' }); closeViewListModal();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  size="defaultSize"
                  variant="contained"
                  onClick={() => {
                    triggerClickTracking({ action: 'add to list modal save' }); createList();
                  }}
                >
                  Save
                </Button>
              </div>
            </RootElement>
          )}
          content={(
            <RootElement onClick={(e) => e.stopPropagation()}>
              {!isOpenCreateNewList
                ? (
                  <div className="Montainer">
                    <div className="create-new-list">
                      {localError ? <Banner type="error"><>{localErrorMessage}</></Banner> : <></>}
                      <Button
                        variant="text"
                        type="button"
                        onClick={() => {
                          triggerClickTracking({ action: 'add to list modal create list' }); openCreateNewListModal();
                        }}
                      >
                        <span>Create a new list</span>
                        <SvgIcon fontSize="small">
                          <AddIcon />
                        </SvgIcon>
                      </Button>
                    </div>
                    <div className="modal-body">
                      <Typography component="h3">Add to my lists</Typography>
                      <ul>
                        {orderedLists ? orderedLists.map((list) => (
                          <li key={list.listId}>
                            <FormControlLabel
                              label={list.listId === LIST_ID_BOOKMARKS ? 'My Bookmarks' : list.title}
                              control={(
                                <Checkbox
                                  defaultChecked={list?.listItems?.find((item) => item.resourceId.endsWith(id))}
                                  onChange={handleCheckboxChange}
                                  inputRef={(element) => checkboxRefs.current[`checkbox${list.listId}`] = element}
                                  name={list.listId === LIST_ID_BOOKMARKS ? 'My Bookmarks' : list.title}
                                />
                              )}
                            />
                          </li>
                        )) : null}
                      </ul>
                    </div>

                  </div>
                )
                : (
                  <div className="Montainer">
                    <div className="new-list-description">
                      Name your list and add a short description. List names cannot exceed
                      {' '}
                      {LIST_TITLE_MAX}
                      {' '}
                      characters. Next, decide if you want your list to be private (only available to you) or available to any user with the link and an Autodesk account.
                    </div>
                    <div className="modal-body">
                      <FormControl
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={titleError !== null}
                        fullWidth
                        id="list-name"
                      >
                        <InputLabel htmlFor="list-name">List name</InputLabel>
                        <TextInput
                          inputRef={titleRef}
                          onChange={handleListTitleOnChange}
                          value={myListTitle}
                          inputProps={{
                            maxLength: LIST_TITLE_MAX,
                          }}
                        />
                        <FormHelperText id="list-name-helper-text">{titleError}</FormHelperText>
                      </FormControl>
                      {titleError ? <></> : (
                        <div className="characters">
                          {'Characters: '}
                          {myListTitle.length || 0}
                          /
                          {LIST_TITLE_MAX}
                        </div>
                      ) }
                      <p className="padding" />
                      <FormControl
                        InputLabelProps={{
                          shrink: true,
                        }}
                        error={descriptionError !== null}
                        fullWidth
                        id="list-desc"
                        hintText="(optional)"
                      >
                        <InputLabel htmlFor="list-desc">List description</InputLabel>
                        <TextInput
                          multiline
                          rows={2}
                          inputRef={descriptionRef}
                          onChange={handleListDescriptionOnChange}
                          value={myListDescription}
                          onInput={(e) => {
                            // eslint-disable-next-line no-param-reassign
                            e.target.value = e.target.value.substr(0, LIST_DESCRIPTION_MAX);
                          }}
                        />
                        <FormHelperText id="list-desc-helper-text">{descriptionError}</FormHelperText>
                      </FormControl>
                      {descriptionError ? <></> : (
                        <div className="characters">
                          {'Characters: '}
                          {myListDescription.length || 0}
                          /
                          {LIST_DESCRIPTION_MAX}
                        </div>
                      ) }
                    </div>
                    <div className="private-list">
                      <div className="toggle-btn">
                        <FormControlLabel control={<Switch defaultChecked inputRef={publicRef} />} label="Private list" />
                      </div>
                      <p>Your list is automatically set to Private. Toggle off Private to share the list with Autodesk account holders.</p>
                    </div>

                  </div>
                )}
            </RootElement>
          )}
        />
      ) : (<></>)}
    </>

  );
};

ListModal.propTypes = {
  displayModal: PropTypes.func.isRequired,
  data: PropTypes.shape({ id: PropTypes.string, objectType: PropTypes.string }).isRequired,
  analyticsArea: PropTypes.string,
};

ListModal.defaultProps = {
  analyticsArea: 'unknown',
};

export default ListModal;
